var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingInterview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 14.6667C11.6816 14.6667 14.6663 11.682 14.6663 8.00007C14.6663 4.31817 11.6816 1.3334 7.99967 1.3334C4.31778 1.3334 1.33301 4.31817 1.33301 8.00007C1.33301 11.682 4.31778 14.6667 7.99967 14.6667ZM8.69412 4.66674C8.69412 4.28321 8.38321 3.97229 7.99968 3.97229C7.61614 3.97229 7.30523 4.28321 7.30523 4.66674V8.00007C7.30523 8.18425 7.3784 8.36088 7.50863 8.49112L9.86565 10.8481C10.1369 11.1193 10.5765 11.1193 10.8477 10.8481C11.1189 10.5769 11.1189 10.1372 10.8477 9.86605L8.69412 7.71242V4.66674Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingInterview);
export default __webpack_public_path__ + "static/media/pending-interview.adc0a48ce7af4b97b5cb23f291d3d105.svg";
export { ForwardRef as ReactComponent };